import React, { Component } from 'react';
import Header from '../../../Layout/Header'
import Sidebar from '../Sidebar'


class BlogItem extends Component {
	render() {
		return (
			<div>
				<Header
					bg="#000000"
					image={require('./image.jpg')}
					title={"COVID-19 Marketing Tools"}
				/>
				<div className="entry-content">
					
					<div className="container">
						<h2 className="blog-details">
								<div className="author-circle lauren"></div>
								<div className="line"></div>
								<div className="title">
									Written by <strong>Lauren</strong> on May   //  Posted in <strong>Marketing, Advertising</strong>
								</div>
						</h2>
						
						<div className="row">
							<div className="col-lg-7">
								<div className="tagline">
								Recent announcements from Facebook and Google aim to help small businesses bounce back during COVID-19. 
								</div>
<h3>The following tools have recently been introduced:</h3>
<ul class="with-icons">
<li>Google Merchant Centre Offers FREE Shopping Placements</li> 

<li>Instagram Introduce New Stickers to Support Local Business</li>

<li>Facebook Looking to Fasttrack Shopping Platform</li>

</ul>
<br></br>
<hr></hr>
<br></br>

     <h2>Google Merchant Centre Offers FREE Shopping Placements</h2> 

								


								<p>In 2019, Google announced that products integrated into the Google Merchant Centre via data feeds would be eligible to be shown on surfaces such as Search and Google images for free. At the time, this was for the US only. </p>

<p>Since the outbreak of Coronavirus worldwide, Google have changed these new policies to reach all locations where Google Merchant Centre is installed - Australia included.</p> 
<p>(If you're not sure what a Google Merchant Centre is or how to run a Google Shopping campaign, <a href="https://www.moshi.com.au/whatwedo/google-advertising">check out this page </a>.)</p>
<p>If you have a Shopping product data feed installed into the Merchant Centre, this essentially means your products are eligible to be shown for free on various Google surfaces. </p>
<br></br>
<hr></hr>
<br></br>
<h2>Steps to take to ensure you qualify for free advertising:</h2>
<h3>Google has released the following guidelines for application.</h3>
<br></br>

<h4>Step 1:</h4> <p>Create a Google Merchant Centre if you don’t have one already. If you are a store selling physical items online and run Google Ads, chances are you will already have a Google Merchant Centre. If not, <a href="https://www.moshi.com.au/contact-us">get in touch</a> and our team can help you out.</p>
<br></br>
<br></br>
<h4>Step 2:</h4> <p>Make sure your product feed is set up correctly. If you’re staring at that sentence thinking ‘what on earth is a product feed?’, we have some more information for you <a href="https://support.google.com/merchants/answer/7439058?hl=en">here</a>. </p>
<br></br>
<br></br>
<h4>Step 3:</h4> <p>Once logged in to your Merchant Account, click <b>Products</b> on the left menu. From there, select <b>Feeds</b>. In the <b>Destination</b> column you should see <b>Surfaces across Google</b>.</p>
<br></br>
<br></br>
<hr></hr>
<br></br>
<h2>Best Practices for Google Shopping</h2>
<h3>Showcase your products the best way possible by following these guides.</h3>
<br></br>

<h4>Use Photographs That are High Resolution:</h4> <p>Think of when you’re browsing online - are you more likely to click on a pixelated, blurry image or a sharp, quality one? The chances of someone clicking on a dark, low res image when there are other high quality images to choose from is low. Low res = low CTR. The higher quality of the image, the perceived higher quality of the item. </p>
<br></br>
<h4>Use Light and Clean Photographs:</h4><p>The same theory applies to lighting and space as resolution. Try using studio or natural light to brighten up the photographs in your product feed. Images that are too dark or too busy are harder to understand quickly, so people move over them. This is why a lot of product feeds you see on Google use a lot fo white space - for good lighting and to draw focus to the product ONLY. </p>
<br></br>
<h4>Use Merchant Centre Data Attributes to Your Advantage</h4><p>You can use the data attributes in Merchant Centre to specify common features in different product options, maximising time efficiency.</p>
<br></br>
<h4>These are:</h4>
<ul>
<li>item_group_id:</li> <p>Use this attribute to group product variants together in your data. Follow the best practices for the item_group_id attribute to ensure your variants are submitted correctly.</p>
<br></br>
<li>color:</li> <p>Submit the primary color of your product. If your product has variants that vary by color, use the item_group_id attribute to submit each of your variants by color.</p>
<br></br>
<li>size:</li> <p>Use these attributes to specify the standardized size of your product. If your product has variants that vary by size, use the item_group_id attribute to submit each of your variants by size.</p>
<br></br>
<li>pattern:</li> <p>Use this to describe the pattern or graphic print on your product. If your product has variants that vary by pattern, use the item_group_id attribute to submit each of your variants by pattern.</p></ul>
<br></br>
<p>You can also define <b>demographic attributes.</b> These include:</p>
<ul>

<li>gender:</li><p> Use this attribute to specify which gender your product is designed for, or submit “unisex” if no gender is specified. We use gender in combination with your size and age_group attributes to standardize sizing and departments that are shown to users (a t-shirt with “male” and “kids” indicated for the gender and age_group could show for “boys t-shirt”).</p>
<br></br>
<li>age_group:</li><p> Use this attribute to indicate which demographic your product is designed for. This attribute is used in combination with gender to help ensure users see the correct size information (“womens” for “adult,” “female” and “girls” for “kids,” “female”). </p></ul>
<br></br>
<hr></hr>
<br></br>
<h4>Make Everything as Easy to Understand as Possible</h4><p>The better your feed is set up, the better Merchant Centre works. Make sure your prices, sizes and product details are all filled out correctly. </p>


<h3>If you have a Google Merchant Centre properly set up already, Google will notify you if your product feed applies for the free Google advertising.</h3>


<br></br>
<hr></hr>
<br></br>

     <h2>Instagram Introduce New Stickers to Support Local Business</h2> 
<p>Instagram introduced three new stickers for users to add to their 'Stories' function this week. These three new stickers are intended to help spread awareness of local businesses operating amidst COVID-19, and to advertise the services linked to these businesses.</p>
<h3>Support Small Business Sticker</h3>
<img src={require('./sticker-1.PNG')} alt="Small Business Sticker" height="250" className="align-left" align="left" /> 
<p> The fist sticker is the 'Support Small Business' sticker. Once this sticker is added to your Story, simply type in the name of the store you are at, and select the look of the badge you like best when your options appear.</p>

<p>Once you've published your Story, a collective Story will appear for that business, with everyone's tagged posts in one location. </p>
<p> <b>The company you've tagged has the option of thanking you or re-posting your Story on their own Story.</b></p>
<p><b>Users that view your story can tap on the tag, and be shown a brief description of the business, including hours, services and/or products.</b></p>
<h3>Delivery/Takeaway Sticker (Food Orders)</h3>
<img src={require('./sticker-2.PNG')} alt="Food Orders Sticker" height="250" className="align-right" align="right" /> 
<p>If your business runs a takeaway or delivery service, use this badge to send people directly to your delivery URL. This is available for businesses using UberEats, Deliveroo or DoorDash.</p>
<p> You can adjust the size of your stickers by pinching and expanding the element with your fingers on your screen. </p>
<h3>Gift Voucher Stickers</h3>
<p>If you run gift vouchers through Gift Up!, Neto, Rise.ai, or TheFork, then this sticker is for you!</p>
<p>Simply add your URL link once you've positioned your sticker, and users will be lead straight to your checkout landing page.</p>

<br></br>
<hr></hr>
<br></br>

     <h2>Facebook Looking to Fasttrack Shopping Platform</h2> 
<img src={require('./image-3.png')} alt="Facebook Shop Example" height="250" className="align-right" align="right" /> 
<p>This morning Facebook introduced plans to fasttrack their Facebook Shops platform - creating a 'seamless online shopping experience' for users.</p> 
<p> This means that all of the businesses moving online (who maybe don't have the budget for full websites), can still reach thier audiences on a global scale, with a seamless, fast loading mobile website.</p>
<p>Customers can be reached through connected apps such as WhatsApp, Messenger or Instagram Direct. To read about setting up one of these Shops, click <a href="https://www.facebook.com/business/help/2343035149322466?id=1077620002609475">here</a></p>
<h3> What does this mean for taking payments over Facebook?</h3>
<p>Nothing has been announced yet as to whether this feature will include the introduction of payments. For now, it is still confined to Messenger or Instagram Direct.</p>
<br></br>
<hr></hr>
<br></br>
<h4>If you need a hand with any of these new tools, feel free to get in touch with the Moshi Moshi Marketing office.</h4>






							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-4">
								<Sidebar />
							</div>
						</div>
					</div>
				</div>

			</div>
		);
	}
}

export default BlogItem;


// WEBPACK FOOTER //
// ./src/Pages/Blog/CovidSocial/index.js